import { sdk, STATIC_MEDIA_URL } from '@wix/image-kit';
export const useResizeImage = () => {
    return ({ imageUrl, originalWidth, originalHeight, toWidth, toHeight }) => {
        const relativeUrl = imageUrl.replace(STATIC_MEDIA_URL, '');
        return sdk.getScaleToFillImageURL(relativeUrl, originalWidth, originalHeight, toWidth, toHeight, { isSEOBot: true });
    };
};
//# sourceMappingURL=image-resize.js.map